import { createCapitalOneTransactionReceiptDocumentLink } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const addStatementDocumentLink = async (props) => {
  console.log('🔗 [LINK] addStatementDocumentLink called with:', props);
  
  if (!props.receiptId || !props.uploadedDocumentId) {
    console.error('❌ [LINK] Missing required parameters:', { 
      receiptId: props.receiptId, 
      uploadedDocumentId: props.uploadedDocumentId 
    });
    throw new Error('Missing receiptId or uploadedDocumentId');
  }

  try {
    const gqlParams = {
      receiptId: props.receiptId,
      uploadedDocumentId: props.uploadedDocumentId,
    };
    console.log('🔗 [LINK] GraphQL params:', gqlParams);

    const response = await client.graphql({
      query: createCapitalOneTransactionReceiptDocumentLink,
      variables: { input: gqlParams },
    });
    
    console.log('🔗 [LINK] Full response:', response);
    
    // Check which field contains the ID based on your GraphQL schema
    let linkId;
    if (response.data?.createSpkCapitalOneTransactionReceiptDocumentLinkTbl?.id) {
      linkId = response.data.createSpkCapitalOneTransactionReceiptDocumentLinkTbl.id;
    } else if (response.data?.createCapitalOneTransactionReceiptDocumentLink?.id) {
      linkId = response.data.createCapitalOneTransactionReceiptDocumentLink.id;
    } else if (response.data?.id) {
      linkId = response.data.id;
    } else {
      console.warn('⚠️ [LINK] Unexpected response structure:', response.data);
      linkId = 'unknown';
    }
    
    console.log('✅ [LINK] Document link created with ID:', linkId);
    return linkId;
    
  } catch (err) {
    console.error('❌ [LINK] Failed to create document link:', {
      error: err,
      message: err.message,
      props: props,
      stack: err.stack
    });
    throw new Error(`Failed to create document link: ${err.message}`);
  }
};

addStatementDocumentLink.propTypes = {
  receiptId: PropTypes.string.isRequired,
  uploadedDocumentId: PropTypes.string.isRequired,
};